<div class="recipe-modal" *ngIf="showRecipe" [ngClass]="{'drop-up': dropUp}">
  <span class="material-icons md-light hoverable modal-close" (click)="closeModal()">close</span>
  <form>
    <div class="form-group w-75 mx-auto">
      <div class="row">
        <div class="col recipe-title">
          <h1>{{recipe.name}}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-3 recipe-info-label">{{message('craftingTableLabel')}}</div>
        <div class="col recipe-info vertical-padding">
          <img [alt]="recipe.craftingTable.name"
               [ngStyle]="imageService.getTableImgStyle(recipe.craftingTable)"
               class="tableSprite mr-2" [src]="imageService.imageTemplateUrl">
          {{recipe.craftingTable.name}}
        </div>
      </div>
      <div class="row">
        <div class="col-3 recipe-info-label">{{message('skillLabel')}}</div>
        <div class="col recipe-info">
          <div class="recipe-element row">
            <div class="col-8">
              <img [alt]="recipe.skill.name"
                   [ngStyle]="imageService.getSkillImgStyle(recipe.skill)"
                   class="skillSprite mr-2" [src]="imageService.imageTemplateUrl">
              {{recipe.skill.name}}
            </div>
            <div class="col-4 d-flex align-items-center">
              <input [value]="recipe.level" class="priceDisplay form-control darker-input read-only recipe-input"
                     readonly type="text">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 recipe-info-label">{{message('laborLabel')}}</div>
        <div class="col recipe-info">
          <div class="recipe-element row">
            <div class="col-8">
              <img [alt]="message('Calories')" class="calorieSprite mr-2"
                   [src]="imageService.imageTemplateUrl"
                   [ngStyle]="imageService.getCalorieImgStyle()">
              {{message('Calories')}}
            </div>
            <div class="col-4 d-flex align-items-center">
              <input [value]="recipe.labor" class="priceDisplay form-control darker-input read-only recipe-input"
                     readonly type="text">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 recipe-info-label">{{message('ingredientsHeader')}}</div>
        <div class="col recipe-info">
          <div class="recipe-element row" *ngFor="let ingredient of recipe.ingredients">
            <div class="col-8">
              <img [alt]=ingredient.item.name
                   [ngStyle]=imageService.getItemImgStyle(ingredient.item)
                   [ngClass]="ingredient.reducible ? 'reducible-item' : 'static-item'"
                   class="itemSprite modal-sprite mr-2" [src]="imageService.imageTemplateUrl">
              {{ingredient.item.name}}
            </div>
            <div class="col-4 text-right d-flex align-items-center">
              <input [value]="ingredient.quantity"
                     class="priceDisplay form-control darker-input read-only recipe-input"
                     readonly type="text">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 recipe-info-label"><span class="vertical-middle">{{message('outputsHeader')}}</span></div>
        <div class="col recipe-info">
          <div class="recipe-element row" *ngFor="let output of recipe.outputs">
            <div class="col-8" [ngClass]="{'primary-output': output.primary}">
              <img [alt]=output.item.name [ngStyle]=imageService.getItemImgStyle(output.item)
                   [ngClass]="{'reducible-item': output.reducible}"
                   class="itemSprite modal-sprite mr-2" [src]="imageService.imageTemplateUrl">
              {{output.item.name}}
            </div>
            <div class="col-4 text-right d-flex align-items-center">
              <input [value]="output.quantity" class="priceDisplay form-control darker-input read-only recipe-input"
                     readonly type="text">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
